import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { EDITOR_SERVICE } from '@core/injection-tokens/editor.injection.token';

import { MaterialModule } from '@material/material.module';
import { FeedbackMenuContentComponent } from '@shared/feedback/menu-content/feedback-menu-content.component';
import { InviteToApplyModule } from '@shared/invite-to-apply/invite-to-apply.module';
import { ThumbModule } from '@shared/thumb/thumb.module';
import { MojoEditorModule } from 'mojo-editor';

import { FeedbackButtonComponent } from './button/feedback-button.component';
import { FeedbackPanelComponent } from './panel/feedback-panel.component';

@NgModule({
  declarations: [FeedbackButtonComponent, FeedbackPanelComponent, FeedbackMenuContentComponent],
  imports: [
    CommonModule,
    MaterialModule,
    ThumbModule,
    MojoEditorModule.forRoot(EDITOR_SERVICE),
    ReactiveFormsModule,
    InviteToApplyModule,
  ],
  exports: [FeedbackButtonComponent, FeedbackPanelComponent, FeedbackMenuContentComponent],
})
export class FeedbackModule {}
